import * as actionTypes from "../ActionTypes";

const initialState = {
  getVendors: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_VENDORS_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_VENDORS_SUCCESS:
      return {
        ...state,
        getVendors: action.payload,
      };
    case actionTypes.GET_VENDORS_FAIL:
      return {
        ...state,
        error: "",
      };
    default:
      return state;
  }
};

export default store;
